import { axios } from '@Root/API'

export const getById = questionsId => {
  return axios.get(`application-institutions/${questionsId}/questions`)
}
